import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import { Thunk } from 'ha/myredux/types';
import { GlobalState } from 'ha/types/store';
import { reportError } from 'ha/helpers/bugsnag/reportError';
import { City } from '@ha/api/v2/types';

export enum ActionTypes {
  START = '[Home] LOAD_CITIES',
  DONE = '[Home] LOAD_CITIES_DONE',
  FAIL = '[Home] LOAD_CITIES_FAIL',
}

export const Actions = {
  start: () => createAction(ActionTypes.START),
  done: (cities: City[]) => createAction(ActionTypes.DONE, cities),
  fail: () => createAction(ActionTypes.FAIL),
};

export type ActionsUnionType = ActionsUnion<typeof Actions>;

type GetCities = (list: string[], lang: string) => Thunk<GlobalState>;

const getCities: GetCities =
  (list, lang) =>
  async (dispatch, _, { apiV2 }) => {
    dispatch(Actions.start());

    const req = {
      list: list.map(item => ({ query: item })),
      languages: [lang],
    };

    return apiV2
      .getCities(req)
      .then(res => {
        const { data: { [lang]: cities = [] } = {} } = res;

        return dispatch(Actions.done(cities));
      })
      .catch(err => {
        reportError('request getCities failed', { metaData: err });

        return dispatch(Actions.fail());
      });
  };

export { getCities };
